<template>
  <div class="d-inline ml-2" v-if="isVisible">
    <b-button variant="danger" @click="onShowModal()">
      {{ 'reject' | translate('global') }}
    </b-button>
    <Modal ref="approve"
           @onClose="closeModal"
           :values="modalValues">
      <template slot="body">
        <div class="modal-body">
          <b-row>
            <b-col cols="12">
              <span>{{ 'order_reject_advance_invoice' | translate('global') }}</span>
              <b-form-group>
                <label>{{ 'comment' | translate('global') }}</label>
                <b-form-textarea type="text" v-model="comment"
                                 :placeholder="'advance_invoice_modal_comment_placeholder' | translate('global')"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </template>
      <template slot="footer">
        <b-button variant="primary" data-dismiss="modal" :disabled="spinners.isSending" @click='onSend()'>
          <b-spinner v-if="spinners.isSending" type="grow" small/>
          {{ 'send' | translate('global') }}
        </b-button>
        <b-button variant="secondary" @click="closeModal()" class="ml-2">
          {{ 'cancel' | translate('global') }}
        </b-button>
      </template>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/views/sharedComponents/Modal';
  import { mapGetters, mapActions } from 'vuex';
  import VuexTypes from '@/store/types/index';
  import statuses from '@/store/statuses';

  const OrdersTypes = VuexTypes.orders;

  export default {
    props: ['id', 'isVisible'],
    components: { Modal },
    computed: {
      ...mapGetters('Orders', [
        'orderDeclineInvoiceAdvanceReview'
      ])
    },
    watch: {
      orderDeclineInvoiceAdvanceReview: {
        handler: function () {
          if (this.orderDeclineInvoiceAdvanceReview.status === statuses.LOADED) {
            this.closeModal();
            this.alertSuccess();
          } else if (this.orderDeclineInvoiceAdvanceReview.status === statuses.ERROR) {
            this.alertError();
          }
          this.spinners.isSending = false;
        },
        deep: true
      }
    },
    data() {
      return {
        spinners: {
          isSending: false
        },
        comment: '',
        modalValues: {
          id: 'decline-advance-invoice',
          title: this.$t('are_you_sure', 'global'),
        }
      }
    },
    methods: {
      ...mapActions('Orders', [
        OrdersTypes.ORDER_DECLINE_INVOICE_ADVANCE_REVIEW
      ]),
      onShowModal(data) {
        this.$refs['approve'].show();
        this.deleteData = data;
      },
      closeModal() {
        this.$refs['approve'].hide();
      },
      onSend() {
        this.spinners.isSending = true;
        this.ORDER_DECLINE_INVOICE_ADVANCE_REVIEW({
          orderId: this.$route.params.id,
          advanceInvoiceId: this.id,
          sendData: {
            comment: this.comment
          }
        });
      },
    }
  }
</script>

<style scoped>
</style>
